import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { take } from 'rxjs';
import { SeminarDateSeriesListModel } from '../../../models/seminar.model';
import { AlertService } from '../../../services/alert.service';
import { CouponService } from '../../../services/coupon.service';
import { SeminarService } from '../../../services/seminar.service';
import { fieldRequired } from '../../../utils/form.utils';
import { getSeminarFirstDateString } from '../../../utils/seminar.utils';
@Component({
  selector: 'app-generate-coupon-codes',
  templateUrl: './generate-coupon-codes.component.html',
  styleUrl: './generate-coupon-codes.component.scss',
  standalone: false,
})
export class GenerateCouponCodesComponent {
  form: FormGroup = new FormGroup({
    title: new FormControl('', [Validators.required]),
    value: new FormControl('', [Validators.required]),
    amount: new FormControl('', [Validators.required]),
    expirationYears: new FormControl(null),
    allowedSeminarIds: new FormControl(null),
    allowedConditionTypes: new FormControl(null),
  });
  public isLoading = false;
  public couponCodes: string[] = [];
  public fieldRequired = fieldRequired;

  public seminars: SeminarDateSeriesListModel[] = [];
  public isLoadingSeminars = false;
  public conditionTypes = [
    { label: 'Regulär', value: 'regular' },
    { label: 'Frühbucher', value: 'early' },
    { label: 'BED Mitglied', value: 'bed' },
    { label: 'Praxis (ab 3 Personen)', value: 'office' },
    { label: 'LOGO Deutschland Mitglied', value: 'logo' },
    { label: 'VDB Mitglied', value: 'vdb' },
    { label: 'VDP Mitglied', value: 'vdp' },
  ];

  public getSeminarDateString = getSeminarFirstDateString;

  constructor(
    private dialogRef: DynamicDialogRef,
    private config: DynamicDialogConfig,
    private couponService: CouponService,
    private alertService: AlertService,
    private seminarService: SeminarService
  ) {
    this.loadSeminars();
  }

  private loadSeminars(): void {
    this.isLoadingSeminars = true;
    this.seminarService
      .getSeminars(true, false)
      .pipe(take(1))
      .subscribe({
        next: seminars => {
          this.seminars = seminars;
          this.isLoadingSeminars = false;
        },
        error: error => {
          console.error('Failed to load seminars', error);
          this.isLoadingSeminars = false;
        },
      });
  }

  public closeDialog(confirmed: boolean) {
    this.dialogRef.close(confirmed);
  }

  public onGenerateCouponCodes() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.isLoading = true;
    this.couponService
      .generateCouponCodes(
        this.form.value.amount,
        this.form.value.title,
        this.form.value.value,
        this.form.value.expirationYears,
        this.form.value.allowedSeminarIds,
        this.form.value.allowedConditionTypes
      )
      .pipe(take(1))
      .subscribe({
        next: couponCodes => {
          this.isLoading = false;
          this.couponCodes = couponCodes;
        },
        error: () => {
          this.isLoading = false;
          this.alertService.showErrorAlert(
            'Fehler beim Generieren der Gutscheine'
          );
        },
      });
  }

  public onCopyCouponCodes() {
    navigator.clipboard.writeText(this.couponCodes.join('\n'));
    this.closeDialog(true);
    this.alertService.showSuccessAlert('Gutscheine erfolgreich kopiert');
  }
}
